import { forceRefetchAlertBannerRoutes } from "@faire/retailer/packages/core/services/AlertBanner/consts";

export const shouldForceRefetchAlertBanner = (routes: string[]) => {
  return routes.some((route) => forceRefetchAlertBannerRoutes.includes(route));
};
